module.exports = __webpack_public_path__ + "img/youhuiquan.2c61c2ad.png";